import { observer } from "mobx-react"
import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { Table } from "semantic-ui-react"
import Price from "components/Price/Price"
import _ from "lodash"
import { Link } from "react-router-dom"
import Responsive from "react-responsive"

@observer
export default class ProductTableReadOnly extends Component {
	static propTypes = {
		list: PropTypes.object,
		cart: PropTypes.object,
		onChange: PropTypes.func,
		products: PropTypes.array,
		minimal: PropTypes.bool
	}

	constructor() {
		super()
	}

	render() {
		let { list, cart, products, onChange, minimal, showTax } = this.props
		let positions = list || products
		if (list) positions = list.products
		let rows = _.map(positions, (product, index) => {
			return (
				<ProductRow showTax={showTax} minimal={minimal} key={index} index={index} onChange={onChange} list={list} cart={cart} product={product} />
			)
		})
		return (
			<Fragment>
				<Responsive minWidth={790}>
					<Table>
						<colgroup>
							<col width="5%" />
							<col width="40%" />
							<col width="" />
							<col width="5%" />
							<col width="10%" />
							<col width="10%" />
						</colgroup>
						<thead>
							<tr>
								<th>&nbsp;</th>
								<th>{translate("Artikel")}</th>
								{!minimal && <th>{translate("Preis/VE")}</th>}
								<th>{translate("VE")}</th>
								<th>{translate("Menge")}</th>
								{showTax && <th>{translate("Steuer")}</th>}
								<th className="tr">
									<div className="tr">{translate("Summe")}</div>
								</th>
							</tr>
						</thead>
						<tbody>
							{rows}
						</tbody>
					</Table>
				</Responsive>
				<Responsive maxWidth={789}>
					<div className="ba br2 b--black-10">
						<table className="w-100">
							<colgroup>
								<col width="10%" />
								<col width="60%" />
								<col width="15%" />
								<col width="15%" />
							</colgroup>
							<thead>
								<tr className="bb b--black-10 w-100 bg-black-05">
									<th className="tl pt3 pb3">&nbsp;</th>
									<th className="tl pt3 pb3">{translate("article")}</th>
									<th className="tl pt3 pb3">{translate("Preis/VE")}</th>
									<th className="tr pt3 pb3 pr2">{translate("Summe")}</th>
								</tr>
							</thead>
							<tbody>
								{rows}
							</tbody>
						</table>
					</div>
				</Responsive>
			</Fragment>
		)
	}
}

const ProductRow = ({ product, minimal, showTax }) => {
	return (
		<Fragment>
			<Responsive minWidth={790}>
				<tr>
					<td>
						<img
							className="db center"
							style={{ maxWidth: "70px", maxHeight: "70px", minWidth: "70px", minHeight: "70px", overflow: "hidden", objectFit: "contain" }}
							src={product.img_src_small}
							alt="" />
					</td>
					<td>
						<Link to={`/product/${product.map_id}`}>
							<strong>{product.article_nr}</strong>
							<div><span className="product-title"><span className="nowrap">{product.title}</span></span></div>
						</Link>
					</td>
					{!minimal && <td>
						<Price>{product.price}</Price>
						<div className="flex flex-row">
							{product.pinfos.gc_rabatt && <a title={translate("Coupon-Rabatt")} className="labelNeu1">&nbsp;&nbsp;{translate("Coupon:")} {product.pinfos.gc_rabatt} %&nbsp;&nbsp;</a>}
							{product.isSale && product.pinfos.sale_percent && <a className="labelNeu1">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>}
						</div>
					</td>}
					<td>
						<div className={"nowrap"}>{product.count} {translate("VE")}</div>
					</td>
					<td>
						<div className={"nowrap"}>{product.unit_multi} {translate("Stück")}</div>
					</td>
					{showTax && <td>
						<div><Price>{product.price * product.count * product.unit_multi * product.taxRate}</Price></div>
						<div className={"black-60"}>{product.taxRate * 100} %</div>
					</td>}
					<td className="tr">
						<div className="tr"><Price>{product.price * product.count * product.unit_multi}</Price></div>
					</td>
				</tr>
			</Responsive>
			<Responsive maxWidth={789}>
				<tr className="bb b--black-10 w-100">
					<td className="pt2 pb2">
						<img
							className="db center"
							style={{ maxWidth: "50px", maxHeight: "50px", minWidth: "50px", minHeight: "50px", overflow: "hidden", objectFit: "contain" }}
							src={product.img_src_small}
							alt="" />
					</td>
					<td className="pt2 pb2">
						<Link to={`/product/${product.map_id}`}>
							<strong>{product.article_nr}</strong> <br />
							<span className="product-title">{product.title}</span>
						</Link>
					</td>
					<td className="pt2 pb2">
						<Price>{product.price}</Price>
						<div className={"nowrap"}>{product.count} {translate("VE")}</div>
					</td>
					<td className="tr pr2 pt2 pb2">
						<div><Price>{product.price * product.count * product.unit_multi}</Price></div>
						<div className="nowrap"><b>{translate("Stück")}:</b> {product.unit_multi * product.count}</div>
					</td>
				</tr>
			</Responsive>
		</Fragment>
	)
}

ProductRow.propTypes = {
	index: PropTypes.any,
	list: PropTypes.object,
	cart: PropTypes.object,
	onChange: PropTypes.func,
	product: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/mags/components/Product/ProductTableReadOnly.js